import React from 'react';
import {Route} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {withTracking} from '@ezcater/tracking-react';
import {gql} from '@apollo/client';
import {EzAppLayout} from '@ezcater/recipe';
import {EzManageNavRoute} from '../EzManageNav';
import {Layout, MainContent} from '../Layout';
import {RequireAuthentication, requireAuthenticationFragment} from '../RequireAuthentication';
import useLiveChat from './useLiveChat';

export const ezManageRouteFragment = gql`
  fragment EzManageRoute on Identity {
    id
    ...RequireAuthentication
  }
  ${requireAuthenticationFragment}
`;

function Content({mainContentOverflowHidden, children}) {
  return (
    <Layout>
      <MainContent overflowHidden={mainContentOverflowHidden}>{children}</MainContent>
    </Layout>
  );
}

const EzManageRoute = ({
  component: Component,
  linkId,
  loggedOutListener,
  renderNav = true,
  requireTermsAndConditions = true,
  requestUrl,
  trackEvent,
  me,
  loading,
  error,
  requireFullAccess = true,
  mainContentOverflowHidden = false,
  ...rest
}) => {
  const {t} = useTranslation();
  const openLiveChat = useLiveChat({t, trackEvent});

  const RenderedComponent = ({match, location, history}) => (
    <RequireAuthentication
      requestUrl={requestUrl}
      loggedOutListener={loggedOutListener}
      me={me}
      loading={loading}
      error={error}
      requireFullAccess={requireFullAccess}
    >
      <Content
        me={me}
        requireTermsAndConditions={requireTermsAndConditions}
        mainContentOverflowHidden={mainContentOverflowHidden}
      >
        <Component match={match} location={location} history={history} />
      </Content>
    </RequireAuthentication>
  );

  if (renderNav) {
    return (
      <React.Fragment>
        <EzAppLayout>
          <EzManageNavRoute
            {...rest}
            linkId={linkId}
            openLiveChat={openLiveChat}
            render={RenderedComponent}
          />
        </EzAppLayout>
      </React.Fragment>
    );
  }

  return <Route {...rest} render={RenderedComponent} />;
};

export default withTracking(EzManageRoute);
